export default __webpack_public_path__ + "static/media/2372.b860cf57.png";